import { CommonModule } from "@angular/common";
import { Component, HostListener, inject, Input } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";

import { ActionButtonComponent } from "../../buttons/action-button/action-button.component";
import {
  ActionButtonSize,
  ActionButtonType,
} from "../../buttons/action-button/action-button.model";
import { TranslateModule } from "@ngx-translate/core";
import { PopUpConfirmInputType } from "./pop-up-confirm.model";

import { MatDialogRef } from "@angular/material/dialog";
import { DropdownComponent } from "../../dropdown/dropdown.component";
import { DropdownOption } from "../../dropdown/dropdown.model";
import { FormInputComponent } from "../../forms/form-input/form-input.component";
import { FormInputType } from "../../forms/form-input/form-input.model";

@Component({
  selector: "app-pop-up-confirm",
  templateUrl: "./pop-up-confirm.component.html",
  styleUrls: ["./pop-up-confirm.component.scss"],
  imports: [
    CommonModule,
    ActionButtonComponent,
    TranslateModule,
    FormsModule,
    DropdownComponent,
    FormInputComponent,
    ReactiveFormsModule,
  ],
  standalone: true,
})
export class PopUpConfirmComponent {
  private dialogRef = inject(MatDialogRef<PopUpConfirmComponent>);

  ActionButtonType = ActionButtonType;
  ActionButtonSize = ActionButtonSize;
  PopUpConfirmInputType = PopUpConfirmInputType;
  FormInputType = FormInputType;

  @HostListener("window:keydown.enter")
  onEnter() {
    this.onConfirm();
  }

  @Input() title: string = "";
  @Input() message: string = "";
  @Input() confirmButtonText: string = "";
  @Input() showInput: boolean = false;
  @Input() inputType: FormInputType = FormInputType.Text;
  @Input() inputPlaceholder: string = "";
  @Input() dropdownPlaceholder: string = "";
  @Input() dropdownOptions: DropdownOption[] = [];
  @Input() maxValue: number | null = null;

  confirmForm!: FormGroup;

  inputValue: string = "";

  ngOnInit() {
    this.confirmForm = new FormGroup({
      input: new FormControl<string>("", [Validators.required]),
    });

    if (this.dropdownOptions.length > 0) {
      this.confirmForm.addControl(
        "dropdown",
        new FormControl<string>("", [Validators.required])
      );
    }
  }

  onConfirm() {
    if (this.confirmForm.valid || !this.showInput) {
      this.dialogRef.close(this.confirmForm.value);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
